import { useCallback, useEffect, useRef, useState } from "react";
import {
  getFieldValuesByTableAndId,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../../api/keyvalue";
import {
  locationValidation,
  reqPhoneValidator,
  validateRequestLocation,
} from "../../../validations/validateRequestCreation";
import SearchDropdown from "../../../input/SearchDropdown";

import {
  addMinutesToDate,
  addMinutesToDateWithoutConvertingToJson,
  formatFromJsonDate,
  isAfter,
  isAfterJson,
  isBefore,
  isBeforeJson,
  isSame,
  subtractMinutesFromDateWithoutConvertingToJson,
  subtractMinutesToDate,
} from "../../../../dateConfig";
import { Info, MapPin, Plus } from "react-feather";
import Grid from "../../../Grid";
import ButtonRenderer from "../../../renderer/ButtonRenderer";
import DateTimePickerInput from "../../../input/DateTimePickerInput";
import UIMessage from "../../../UIMessage";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../../store/request-slice";
import Modal from "../../../Modal";
import LocationDetails from "../../LocationDetails";
import Button from "../../../input/Button";
import { ResizableScrollingTextRenderer } from "../../../renderer/StyleRenderer";
import { AUTH_TYPES, CONFIGS, FORMS, MODULES } from "../../../../const";
import { isNumber } from "../../../../helper";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../LoadingSpinner";
import useFormVisibility from "../../../../hooks/useFormVisibility";
import useDynamicValidation from "../../../../hooks/useDynamicValidation";
import Input from "../../../input/Input";
import Dropdown from "../../../input/Dropdown";
import AddViaLocations from "../../AddViaLocations";
import useFieldVisibility from "../../../../hooks/useFieldVisibility";
import { stakeholderConfigByStakeholderAndConfig } from "../../../../api/stakeholderapi";
import DeleteButtonRenderer from "../../../renderer/DeleteButtonRenderer";
// import { Dropdown, Menu } from "semantic-ui-react";

const FORM = FORMS.REQUEST.LOCATION.form;
const VIA_LOCATION = FORMS.REQUEST.VIA_LOCATION.form;
const START_LOCATION = FORMS.REQUEST.START_LOCATION.form;
const END_LOCATION = FORMS.REQUEST.END_LOCATION.form;
const MAIN_FORM = FORMS.REQUEST.CREATION.form;

const RequestLocationsRequest = ({
  editMode,
  onShowLocation,
  isLoading,
  context,
  dropdown,
}) => {
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction]
  );

  const customerId = useSelector((state) => state.request.reqLCustomerId);
  console.log("customerId", customerId);
  const allowSameLocation = useSelector(
    (state) => state.request.allowSameLocations
  );

  const isFormVisibilityLoading = useSelector(
    (state) => state.formVisibility.loading
  );

  const sameLocationAllowedCheckLoading = useSelector(
    (state) => state.request.sameLocationAllowedCheckLoading
  );

  useFormVisibility({
    form: FORM,
    keyValue: customerId ? "stakeholder" : "default",
    type: customerId ?? 1,
    useDynamicFields: true,
  });

  useFormVisibility({
    form: START_LOCATION,
    keyValue: customerId ? "stakeholder" : "default",
    type: customerId ?? 1,
    useDynamicFields: true,
  });

  useFormVisibility({
    form: END_LOCATION,
    keyValue: customerId ? "stakeholder" : "default",
    type: customerId ?? 1,
    useDynamicFields: true,
  });

  useFormVisibility({
    form: VIA_LOCATION,
    keyValue: customerId ? "stakeholder" : "default",
    type: customerId ?? 1,
    useDynamicFields: true,
  });

  const { visible: isBulkAddVisbile } = useFieldVisibility({
    form: VIA_LOCATION,
    field: "bulk_add",
    useDynamicFields: true,
  });

  const { visible: isViaLocationsVisible } = useFieldVisibility({
    form: VIA_LOCATION,
    field: "via_section",
    useDynamicFields: true,
  });

  const dynamicValidationStatus = useDynamicValidation(
    locationValidation,
    VIA_LOCATION,
    true
  );

  const mainFormPermissions = auth?.[MAIN_FORM];

  const allowBackDates = mainFormPermissions?.FORM?.REQUEST_BACK_DATE;
  const allowBulkAddViaLocations = auth?.[FORM]?.BULK_ADD?.VIEW;

  const startLocationRef = useRef();
  const endLocationRef = useRef();

  const locations = useSelector(
    (state) => state.request.requestLocationsRequests
  );

  const reqBookingRequiredDate = useSelector(
    (state) => state.request.reqBookingRequiredDate
  );

  const viaLocationRef = useRef();

  const [seq, setSeq] = useState(2);
  const [requestStartLocation, setRequestStartLocation] = useState({
    rlkLocation: null,
    rlkLocationType: 1,
    rlkArrivalEta: "",
    rlkArrivalEtaFormatted: "",
    rlkDepartureEta: "",
    rlkDepartureEtaFormatted: "",
    locationName: "",
    rlkLoadingTime: null,
    rlkUnloadingTime: null,
    rlkContactPersonId: null,
    rlkAddress: "",
    rlkContactNumber: "",
    rlkEmail: "",
    rlkLon: "",
    rlkLat: "",
    rlkActive: 1,
    rlkSeq: 1,
    requestConsigneesRequests: [],
    rlkLocationContactNumber: "",
    rlkLocationContactName: "",
    rlkLocationTimeUpdated: false,
    rlkPickDrop: 1,
  });

  const [requestEndLocation, setRequestEndLocation] = useState({
    rlkLocation: null,
    rlkLocationType: 2,
    rlkArrivalEta: "",
    rlkArrivalEtaFormatted: "",
    rlkDepartureEta: "",
    rlkDepartureEtaFormatted: "",
    locationName: "",
    rlkLoadingTime: null,
    rlkUnloadingTime: null,
    rlkContactPersonId: null,
    rlkAddress: "",
    rlkContactNumber: "",
    rlkEmail: "",
    rlkLon: "",
    rlkLat: "",
    rlkActive: 1,
    rlkSeq: seq + 1,
    requestConsigneesRequests: [],
    rlkLocationContactNumber: "",
    rlkLocationContactName: "",
    rlkLocationTimeUpdated: false,
    rlkPickDrop: 2,
  });

  const [items, setItems] = useState([]);

  const [requestViaLocation, setRequestViaLocation] = useState({
    rlkLocation: null,
    rlkLocationType: 3,
    rlkArrivalEta: "",
    rlkArrivalEtaFormatted: "",
    rlkDepartureEta: "",
    rlkDepartureEtaFormatted: "",
    locationName: "",
    rlkLoadingTime: null,
    rlkUnloadingTime: null,
    rlkContactPersonId: null,
    rlkAddress: "",
    rlkContactNumber: "",
    rlkEmail: "",
    rlkLon: "",
    rlkLat: "",
    rlkSeq: null,
    rlkActive: 1,
    requestConsigneesRequests: [],
    rlkLocationContactNumber: "",
    rlkLocationContactName: "",
    rlkLocationTimeUpdated: false,
    rlkPickDrop: null,
    rlkPickDropValue: "",
  });

  const [popupContentConst, setPopUpContentConst] = useState();

  const modalRef = useRef();
  const startLocationErrors = useSelector(
    (state) => state.request.startLocationErrors
  );
  const endLocationErrors = useSelector(
    (state) => state.request.endLocationErrors
  );
  const validationErrors = useSelector(
    (state) => state.request.validationErrors
  );

  const [currentStartLocationErrors, setCurrentStartLocationErrors] =
    useState(startLocationErrors);
  const [currentEndLocationErrors, setCurrentEndLocationErrors] =
    useState(endLocationErrors);

  useEffect(() => {
    setCurrentStartLocationErrors(startLocationErrors);
  }, [startLocationErrors]);

  useEffect(() => {
    setCurrentEndLocationErrors(endLocationErrors);
  }, [endLocationErrors]);

  const [isAddLoading, setIsAddLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [errors, setErrors] = useState("");
  const [count, setCount] = useState(2);
  const [currentItem, setCurrentItem] = useState({});
  const [dragStart, setDragStart] = useState(null);
  const [dragStop, setDragStop] = useState(null);
  const [rowDragDroped, setRowDragDroped] = useState(false);
  const [gridLoading, setGridLoading] = useState(false);

  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [viaSearchFieldReset, setViaSearchFieldReset] = useState(false);
  const dispatch = useDispatch();

  const [currentViaLocations, setCurrentViaLocations] = useState([]);
  const [timeGapInMins, setTimeGapInMins] = useState(1);
  console.log("timeGapInMins", timeGapInMins);
  useEffect(() => {
    (async () => {
      if(customerId){
        const timeGapConfig = await stakeholderConfigByStakeholderAndConfig(
          customerId,
          CONFIGS.REQUEST_CREATION_LOCATION_TIME_GAP
        );
        console.log("timeGapConfig", timeGapConfig);
        if (timeGapConfig) {
          setTimeGapInMins(timeGapConfig.scnNumber);
        }
      }
    })();
  }, [customerId]);

  const getAllLocationWOEndLocMap = () => {
    let locationMap =
      requestStartLocation.rlkLocation === null
        ? {}
        : { 1: requestStartLocation.rlkLocation };
    for (const via of items) {
      locationMap = { ...locationMap, [via.rlkSeq]: via.rlkLocation };
    }

    return locationMap;
  };

  const isLocationOrderInvalid = (locSeq, rlkId) => {
    let allLocationMap = getAllLocationWOEndLocMap();
    allLocationMap = { ...allLocationMap, [locSeq]: rlkId };
    if (requestEndLocation.rlkLocation !== null) {
      allLocationMap = {
        ...allLocationMap,
        [locSeq === seq ? seq + 1 : seq]: requestEndLocation.rlkLocation,
      };
    }

    return haveConsecutiveLocations(allLocationMap);
  };

  const haveConsecutiveLocations = (locationMap) => {
    if (allowSameLocation) {
      return false;
    }
    const minSeq = Math.min(...Object.keys(locationMap).map((seq) => +seq));

    let prevLocation = locationMap[minSeq];
    for (let i = minSeq + 1; i <= seq + 1; i++) {
      const currentLocation =
        locationMap[i] === undefined ? -1 : locationMap[i];

      if (currentLocation === -1) {
        return false;
      }

      if (currentLocation === prevLocation) {
        return true;
      }
      prevLocation = currentLocation;
    }
    return false;
  };

  const organizeLocations = (locations) => {
    let startLocation = null;
    let endLocation = null;
    let viaLocations = [];

    locations.forEach((location) => {
      if (location.rlkLocationType === 1 && !startLocation) {
        startLocation = location;
      } else if (location.rlkLocationType === 2 && !endLocation) {
        endLocation = location;
      } else if (location.rlkLocationType === 3) {
        viaLocations.push(location);
      }
    });

    // Remove duplicates or unnecessary repetitions if needed
    return { startLocation, viaLocations, endLocation };
  };

  useEffect(() => {
    if (rowDragDroped) {
      if (dragStart === dragStop) {
        setRowDragDroped(false);
        setDragStart(null);
        setDragStop(null);
        return;
      }
      let locationsToUpdate = [];
      let updatedLocations = [];
      setGridLoading(true);
      if (dragStop < dragStart) {
        locationsToUpdate = items
          .filter((location) => {
            return location.rlkSeq >= dragStop && location.rlkSeq <= dragStart;
          })
          .sort((a, b) => a.rlkSeq - b.rlkSeq);
        const dragStartLocation =
          locationsToUpdate[locationsToUpdate.length - 1];
        const dragStopLocation = locationsToUpdate[0];

        updatedLocations.push({
          ...dragStartLocation,
          rlkSeq: dragStopLocation.rlkSeq,
          rlkArrivalEta: dragStopLocation.rlkArrivalEta,
          rlkArrivalEtaFormatted: dragStopLocation.rlkArrivalEtaFormatted,
          rlkDepartureEta: dragStopLocation.rlkDepartureEta,
          rlkDepartureEtaFormatted: dragStopLocation.rlkDepartureEtaFormatted,
          rlkLocationContactNumber: dragStopLocation.rlkLocationContactNumber,
          rlkLocationContactName: dragStopLocation.rlkLocationContactName,
        });
        let prevLocation = locationsToUpdate[1];
        for (let i = 1; i < locationsToUpdate.length; i++) {
          let currentLocation = locationsToUpdate[i];
          if (i === 1) {
            updatedLocations.push({
              ...dragStopLocation,
              rlkSeq: prevLocation.rlkSeq,
              rlkArrivalEta: prevLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: prevLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: prevLocation.rlkDepartureEta,
              rlkDepartureEtaFormatted: prevLocation.rlkDepartureEtaFormatted,
              rlkLocationContactNumber: prevLocation.rlkLocationContactNumber,
              rlkLocationContactName: prevLocation.rlkLocationContactName,
            });
          } else {
            updatedLocations.push({
              ...prevLocation,
              rlkSeq: currentLocation.rlkSeq,
              rlkArrivalEta: currentLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: currentLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: currentLocation.rlkDepartureEta,
              rlkLocationContactNumber:
                currentLocation.rlkLocationContactNumber,
              rlkLocationContactName: currentLocation.rlkLocationContactName,
              rlkDepartureEtaFormatted:
                currentLocation.rlkDepartureEtaFormatted,
            });
            prevLocation = currentLocation;
          }
        }
        for (let location of items) {
          if (location.rlkSeq < dragStop || location.rlkSeq > dragStart) {
            updatedLocations.push(location);
          }
        }
      } else {
        locationsToUpdate = items
          .filter((location) => {
            return location.rlkSeq >= dragStart && location.rlkSeq <= dragStop;
          })
          .sort((a, b) => a.rlkSeq - b.rlkSeq);
        const dragStartLocation = locationsToUpdate[0];
        const dragStopLocation =
          locationsToUpdate[locationsToUpdate.length - 1];

        updatedLocations.push({
          ...dragStartLocation,
          rlkSeq: dragStopLocation.rlkSeq,
          rlkArrivalEta: dragStopLocation.rlkArrivalEta,
          rlkArrivalEtaFormatted: dragStopLocation.rlkArrivalEtaFormatted,
          rlkDepartureEta: dragStopLocation.rlkDepartureEta,
          rlkDepartureEtaFormatted: dragStopLocation.rlkDepartureEtaFormatted,
          rlkLocationContactNumber: dragStopLocation.rlkLocationContactNumber,
          rlkLocationContactName: dragStopLocation.rlkLocationContactName,
        });
        let prevLocation = locationsToUpdate[locationsToUpdate.length - 2];
        for (let i = locationsToUpdate.length - 2; i >= 0; i--) {
          let currentLocation = locationsToUpdate[i];
          if (i === locationsToUpdate.length - 2) {
            updatedLocations.push({
              ...dragStopLocation,
              rlkSeq: prevLocation.rlkSeq,
              rlkArrivalEta: prevLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: prevLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: prevLocation.rlkDepartureEta,
              rlkDepartureEtaFormatted: prevLocation.rlkDepartureEtaFormatted,
              rlkLocationContactNumber: prevLocation.rlkLocationContactNumber,
              rlkLocationContactName: prevLocation.rlkLocationContactName,
            });
          } else {
            updatedLocations.push({
              ...prevLocation,
              rlkSeq: currentLocation.rlkSeq,
              rlkArrivalEta: currentLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: currentLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: currentLocation.rlkDepartureEta,
              rlkDepartureEtaFormatted:
                currentLocation.rlkDepartureEtaFormatted,
              rlkLocationContactNumber:
                currentLocation.rlkLocationContactNumber,
              rlkLocationContactName: currentLocation.rlkLocationContactName,
            });
            prevLocation = currentLocation;
          }
        }

        for (let location of items) {
          if (location.rlkSeq < dragStart || location.rlkSeq > dragStop) {
            updatedLocations.push(location);
          }
        }
      }
      const sortedLocations = updatedLocations.sort(
        (a, b) => a.rlkSeq - b.rlkSeq
      );
      let locationMap = {
        1: requestStartLocation.rlkLocation,
        ...sortedLocations.reduce((acc, item) => {
          acc[item.rlkSeq] = item.rlkLocation;
          return acc;
        }, {}),
      };
      if (requestEndLocation.rlkLocation !== null) {
        locationMap = { ...locationMap, [seq]: requestEndLocation.rlkLocation };
      }
      if (haveConsecutiveLocations(locationMap)) {
        toast.warn("Invalid Location order", {
          autoClose: 5000,
          containerId: "Main",
        });
        setRowDragDroped(false);
        setGridLoading(false);
        return;
      }
      setItems(sortedLocations);
      dispatch(requestActions.updateLocations(sortedLocations));
      setRowDragDroped(false);
      setGridLoading(false);
    }
  }, [rowDragDroped, items, dragStart, dragStop, dispatch]);

  const onRowDragEnter = useCallback((e) => {
    setDragStart(e.overIndex + 2);
  }, []);

  const onRowDragEnd = useCallback((e) => {
    setDragStop(e.overIndex + 2);
    setRowDragDroped(true);
  }, []);

  const locationCustomerId = useSelector(
    (state) => state.request.reqLCustomerId
  );

  const viewOnlyMode = useSelector((state) => state.request.viewOnlyMode);

  const currentData = useSelector(
    (state) => state.request.currentValues.requestLocations
  );
  const [popupKey, setPopupKey] = useState(1);

  const getPreviousLocation = (curreSeq) => {
    const viaLocations = items.filter((item) => item.rlkLocationType === 3);

    if (!curreSeq) {
      curreSeq = seq;
    }

    for (let i = curreSeq - 1; i > 1; i--) {
      const location = viaLocations.find((item) => item.rlkSeq === i);
      if (location) {
        return location;
      }
    }
    return null;
  };

  const getFirstViaLocation = () => {
    const viaLocations = items.filter((item) => item.rlkLocationType === 3);
    for (let i = 2; i <= seq; i++) {
      const location = viaLocations.find((item) => item.rlkSeq === i);
      if (location) {
        return location;
      }
    }
    return null;
  };

  useEffect(() => {
    const { viaLocations, endLocation } = organizeLocations(locations);
    // Set the states for start, via, and end locations
    // setRequestStartLocation(startLocation);
    const filteredViaLocations = viaLocations.filter(
      (rlk) => rlk.rlkActive === 1
    );
    setRequestEndLocation(endLocation);
    setItems(filteredViaLocations);
  }, [locations]);

  useEffect(() => {
    (async () => {
      if (editMode && currentData) {
        setCurrentViaLocations(
          currentData
            ? currentData?.requestViaLocations
              ? [...currentData?.requestViaLocations].sort(
                  (a, b) => a.rlkSeq - b.rlkSeq
                )
              : []
            : []
        );
        setRequestStartLocation({
          ...currentData?.requestStartLocation,
        });
        setRequestEndLocation({
          ...currentData?.requestEndLocation,
        });
      }
    })();
  }, [currentData, editMode, locationCustomerId]);

  useEffect(() => {
    (async () => {
      if (editMode) {
        let currentLocs = [];
        let id = 4;
        let sequence = 2;
        for (let value of currentViaLocations) {
          currentLocs.push({
            ...value,
          });
          id++;
          sequence++;
        }
        setCount(id);
        setSeq(sequence);

        setItems(currentLocs);
      }
    })();
  }, [editMode, currentViaLocations, locationCustomerId, setSeq]);

  useEffect(() => {
    if (Object.keys(currentItem).length > 0) {
      setRequestViaLocation({
        ...currentItem,
      });
    }
  }, [editMode, currentItem, setRequestViaLocation]);

  useEffect(() => {
    if (buttonClicked) {
      setRequestViaLocation({
        rlkLocation: null,
        rlkLocationType: 3,
        rlkArrivalEta: "",
        rlkArrivalEtaFormatted: "",
        rlkDepartureEta: "",
        rlkDepartureEtaFormatted: "",
        rlkLoadingTime: null,
        rlkUnloadingTime: null,
        rlkContactPersonId: null,
        rlkContactPersonValue: "",
        rlkAddress: "",
        rlkContactNumber: "",
        locationName: "",
        rlkEmail: "",
        rlkLon: "",
        rlkLat: "",
        rlkSeq: null,
        rlkActive: 1,
        requestConsigneesRequests: [],
        rlkLocationContactNumber: "",
        rlkLocationContactName: "",
        rlkLocationTimeUpdated: false,
        rlkPickDrop: null,
        rlkPickDropValue: "",
      });
      setViaSearchFieldReset(true);
      setErrors({});
      setCurrentItem({});
      setButtonClicked(false);
    }
  }, [buttonClicked, setRequestViaLocation]);

  const openPopUp = (content) => {
    setPopupKey((prevKey) => prevKey + 1);
    setPopUpContentConst(content);
    modalRef.current?.showModal();
  };

  const closePopUp = () => {
    modalRef.current?.close();
  };

  const getLabelData = async () => {
    const locationResponse = await getOtherRefDetails({
      type: "location_customer",
      value: locationCustomerId?.toString(),
      param2: requestViaLocation.rlkLocation?.toString(),
    });
    const locationDetails =
      locationResponse && locationResponse.length > 0
        ? locationResponse[0]
        : {};

    const rlkLocationTypeValue = await getTextByValueAndKey(
      "rlk_location",
      requestViaLocation.rlkLocationType
    );

    const contactPersonResponse = requestViaLocation.rlkContactPersonId
      ? await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_contacts",
          ids: requestViaLocation.rlkContactPersonId?.toString(),
          primaryKey: "con_id",
          fieldNames: "con_name",
        })
      : null;

    const rlkContactPersonValue = contactPersonResponse
      ? contactPersonResponse[0].field1
      : "";

    const rlkPickDropTypeValue = await getTextByValueAndKey(
      "pick_drop_type",
      requestViaLocation.rlkPickDrop
    );

    return {
      locationDetails,
      rlkLocationTypeValue,
      rlkContactPersonValue,
      rlkPickDropTypeValue,
    };
  };

  let popUpContent = <></>;

  const popupConst = {
    MAP_LOCATION: "MAP_LOCATION",
    START_LOCATION_DETAILS: "START_LOCATION_DETAILS",
    END_LOCATION_DETAILS: "END_LOCATION_DETAILS",
    VIA_LOCATION_DETAILS: "VIA_LOCATION_DETAILS",
    VIA_LOCATION_ADD: "VIA_LOCATION_ADD",
  };

  switch (popupContentConst) {
    case popupConst.MAP_LOCATION: {
      popUpContent = <></>;
      break;
    }
    case popupConst.START_LOCATION_DETAILS: {
      popUpContent = (
        <LocationDetails
          locationId={requestStartLocation?.rlkLocation}
          locationCustomerId={locationCustomerId}
        />
      );
      break;
    }
    case popupConst.END_LOCATION_DETAILS: {
      popUpContent = (
        <LocationDetails
          locationId={requestEndLocation?.rlkLocation}
          locationCustomerId={locationCustomerId}
        />
      );
      break;
    }
    case popupConst.VIA_LOCATION_DETAILS: {
      popUpContent = (
        <LocationDetails
          locationId={requestViaLocation.rlkLocation}
          locationCustomerId={locationCustomerId}
        />
      );
      break;
    }
    case popupConst.VIA_LOCATION_ADD: {
      popUpContent = (
        <AddViaLocations
          getPreviousLocation={getPreviousLocation}
          requestStartLocation={requestStartLocation}
          requestEndLocation={requestEndLocation}
          items={items}
          setItems={setItems}
          isLocationOrderInvalid={isLocationOrderInvalid}
          getLabelData={getLabelData}
          seq={seq}
          setSeq={setSeq}
          count={count}
          setCount={setCount}
          locationCustomerId={locationCustomerId}
          editMode={editMode}
          VIA_LOCATION={VIA_LOCATION}
          viewOnlyMode={viewOnlyMode}
          closePopUp={closePopUp}
          key={popupKey}
          dropdown={dropdown}
        />
      );
      break;
    }
    default:
      popUpContent = <></>;
  }

  const onAddClick = async () => {
    setIsAddLoading(true);

    const requestLocationErrors = validateRequestLocation(
      {
        ...requestViaLocation,
        rlkContactPersonId: requestViaLocation.rlkContactPersonId || null,
        rlkLocationContactName:
          requestViaLocation.rlkLocationContactName || null,
        rlkLocationContactNumber:
          requestViaLocation.rlkLocationContactNumber || null,
      },
      dynamicValidationStatus
    );

    const prevLocation = getPreviousLocation(requestViaLocation.rlkSeq);

    if (Object.keys(requestLocationErrors).length === 0) {
      // Validate departure date is after arrival date
      if (
        isAfterJson(
          requestViaLocation.rlkArrivalEta,
          requestViaLocation.rlkDepartureEta
        )
      ) {
        requestLocationErrors.rlkDepartureEta =
          "Departure date should be after arrival date";
        setErrors(requestLocationErrors);
        document.querySelector(".ui.form").classList.add("error");
        setIsAddLoading(false);
        return;
      }

      // Validate arrival time after the previous location's departure time
      if (prevLocation) {
        if (
          !isAfterJson(
            requestViaLocation.rlkArrivalEta,
            prevLocation.rlkDepartureEta
          )
        ) {
          requestLocationErrors.rlkArrivalEta =
            "Arrival date should be after previous location departure date";
          setErrors(requestLocationErrors);
          document.querySelector(".ui.form").classList.add("error");
          setIsAddLoading(false);
          return;
        }
      }

      if (!requestViaLocation.rlkId) {
        if (!requestViaLocation.id) {
          const {
            locationDetails,
            rlkLocationTypeValue,
            rlkContactPersonValue,
            rlkPickDropTypeValue,
          } = await getLabelData();
          setItems((prevState) => [
            ...prevState,
            {
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField10,
              rlkLat: locationDetails.retField9,
              rlkLocationTypeValue,
              rlkContactPersonValue,
              rlkPickDropValue: rlkPickDropTypeValue,
              rlkSeq: seq,
              id: count,
            },
          ]);
          dispatch(
            requestActions.addLocation({
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField9,
              rlkLat: locationDetails.retField10,
              rlkLocationTypeValue,
              rlkContactPersonValue,
              rlkPickDropValue: rlkPickDropTypeValue,
              rlkSeq: seq,
              id: count,
            })
          );
          setSeq((prevState) => prevState + 1);
          setCount((prevState) => prevState + 1);
        } else {
          const {
            locationDetails,
            rlkLocationTypeValue,
            rlkContactPersonValue,
            rlkPickDropTypeValue,
          } = await getLabelData();
          setItems((prevState) =>
            prevState.filter(
              (container) => container.id !== requestViaLocation.id
            )
          );

          setItems((prevState) => [
            ...prevState,
            {
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField9,
              rlkLat: locationDetails.retField10,
              rlkContactPersonValue,
              rlkLocationTypeValue,
              rlkPickDropValue: rlkPickDropTypeValue,
            },
          ]);

          dispatch(
            requestActions.updateNonPersistedLocation({
              id: requestViaLocation.id,
              location: {
                ...requestViaLocation,
                locationName: locationDetails.retField1,
                rlkAddress: locationDetails.retField2,
                rlkEmail: locationDetails.retField6,
                rlkContactNumber: locationDetails.retField5,
                rlkLon: locationDetails.retField9,
                rlkLat: locationDetails.retField10,
                rlkContactPersonValue,
                rlkLocationTypeValue,
                rlkPickDropValue: rlkPickDropTypeValue,
              },
            })
          );
        }
      } else {
        const {
          locationDetails,
          rlkLocationTypeValue,
          rlkContactPersonValue,
          rlkPickDropTypeValue,
        } = await getLabelData();
        setItems((prevState) =>
          prevState.map((loc) => {
            if (loc.rlkId === requestViaLocation.rlkId) {
              return {
                ...requestViaLocation,
                locationName: locationDetails.retField1,
                rlkAddress: locationDetails.retField2,
                rlkEmail: locationDetails.retField6,
                rlkContactNumber: locationDetails.retField5,
                rlkLon: locationDetails.retField9,
                rlkLat: locationDetails.retField10,
                rlkContactPersonValue,
                rlkLocationTypeValue,
                rlkPickDropValue: rlkPickDropTypeValue,
              };
            }
            return loc;
          })
        );
        dispatch(
          requestActions.updatePersistedLocation({
            rlkId: requestViaLocation.rlkId,
            location: {
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField9,
              rlkLat: locationDetails.retField10,
              rlkContactPersonValue,
              rlkLocationTypeValue,
            },
          })
        );
      }
      setButtonClicked(true);
    } else {
      setErrors(requestLocationErrors);
      document.querySelector(".ui.form").classList.add("error");
    }
    setIsAddLoading(false);
  };

  return (
    <div>
      {isLoading ||
      isFormVisibilityLoading ||
      sameLocationAllowedCheckLoading ? (
        <LoadingSpinner />
      ) : (
        <div>
          <Modal ref={modalRef}>{popUpContent}</Modal>
          <form className="ui form">
            <div className="ui segment">
              <h4 className="ui dividing header">Location Info</h4>
              <div className="field">
                <div className="ui segment">
                  <h4 className="ui dividing header">Start Location</h4>
                  <div className="two fields">
                    <SearchDropdown
                      readOnly={
                        viewOnlyMode ||
                        (editMode &&
                          requestStartLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      editMode={editMode}
                      multiGrid={true}
                      multiGridCurrentValue={requestStartLocation?.locationName}
                      form={START_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_start_location"
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      api={getOtherRefDetails}
                      returnFullObject={true}
                      ref={startLocationRef}
                      threshold={1}
                      apiDependency={{
                        type: "location_customer",
                        value: locationCustomerId?.toString(),
                      }}
                      clearable={true}
                      onClear={() => {
                        dispatch(
                          requestActions.setStartLocation({
                            locationName: "",
                            rlkAddress: "",
                            rlkEmail: "",
                            rlkContactNumber: "",
                            rlkLon: null,
                            rlkLat: null,
                            rlkLocation: null,
                            rlkPickDrop: 1,
                          })
                        );
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          locationName: "",
                          rlkAddress: "",
                          rlkEmail: "",
                          rlkContactNumber: "",
                          rlkLon: null,
                          rlkLat: null,
                          rlkLocation: null,
                          rlkPickDrop: 1,
                        }));
                      }}
                      onResultSelect={(data) => {
                        dispatch(
                          requestActions.setStartLocation({
                            locationName: data.retField1,
                            rlkAddress: data.retField2,
                            rlkEmail: data.retField6,
                            rlkContactNumber: data.retField5,
                            rlkLon: data.retField9,
                            rlkLat: data.retField10,
                            rlkLocation: data.value,
                            rlkPickDrop: 1,
                          })
                        );
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          locationName: data.retField1,
                          rlkAddress: data.retField2,
                          rlkEmail: data.retField6,
                          rlkContactNumber: data.retField5,
                          rlkLon: data.retField9,
                          rlkLat: data.retField10,
                          rlkLocation: data.value,
                          rlkPickDrop: 1,
                        }));
                      }}
                      required={true}
                      label="Location"
                      error={currentStartLocationErrors.rlkLocation}
                      resetError={() =>
                        setCurrentStartLocationErrors((prevState) => {
                          const { rlkLocation: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />

                    <SearchDropdown
                      readOnly={
                        viewOnlyMode ||
                        (editMode &&
                          requestStartLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      editMode={editMode}
                      form={START_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_start_contact_person"
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      api={getOtherRefSearchDropdown}
                      value={requestStartLocation?.rlkContactPersonId}
                      apiDependency={{
                        type: "contact_person",
                        value: locationCustomerId?.toString(),
                      }}
                      clearable={true}
                      onClear={() => {
                        dispatch(
                          requestActions.setStartLocation({
                            rlkContactPersonId: null,
                          })
                        );
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          rlkContactPersonId: null,
                        }));
                      }}
                      onResultSelect={(data) => {
                        dispatch(
                          requestActions.setStartLocation({
                            rlkContactPersonId: data,
                          })
                        );
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          rlkContactPersonId: data,
                        }));
                      }}
                      fieldInfo={{
                        tableName: "masterdata.tms_m_contacts",
                        primaryKey: "con_id",
                        fieldName: "con_name",
                        id: requestStartLocation?.rlkContactPersonId,
                      }}
                      label="Contact Person"
                      error={currentStartLocationErrors.rlkContactPersonId}
                      resetError={() =>
                        setCurrentStartLocationErrors((prevState) => {
                          const { rlkContactPersonId: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                  </div>
                  <div className="two fields">
                    <DateTimePickerInput
                      readOnly={
                        viewOnlyMode ||
                        (editMode &&
                          requestStartLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      form={START_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_start_arrival_eta"
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      value={requestStartLocation?.rlkArrivalEta}
                      style={{
                        borderColor: errors.departureTime ? "red" : "",
                      }}
                      onAccept={(value) => {
                        dispatch(
                          requestActions.setStartLocation({
                            rlkArrivalEta: value,
                          })
                        );
                        // if (!reqBookingRequiredDate) {
                        dispatch(
                          requestActions.setRequest({
                            startArrivalTime: value,
                          })
                        );
                        // }
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          rlkArrivalEta: value,
                          rlkArrivalEtaFormatted: formatFromJsonDate(value),
                        }));
                      }}
                      validators={
                        !allowBackDates
                          ? [
                              {
                                func: (date) => isAfter(date, new Date()),
                                message:
                                  "Date and time should be after current date and time",
                              },
                              {
                                func: (date) => {
                                  if (!requestStartLocation?.rlkDepartureEta)
                                    return true;

                                  const minArrival =
                                    subtractMinutesFromDateWithoutConvertingToJson(
                                      requestStartLocation?.rlkDepartureEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minArrival) ||
                                    isBefore(date, minArrival)
                                  );
                                },
                                message: `Arrival must be at least ${timeGapInMins} minutes before departure`,
                              },
                              {
                                func: (date) => {
                                  if (requestStartLocation?.rlkDepartureEta) {
                                    return isBefore(
                                      date,
                                      requestStartLocation?.rlkDepartureEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Arrival Date should be before departure date",
                              },
                              {
                                func: (date) => {
                                  if (requestEndLocation?.rlkArrivalEta) {
                                    return isBefore(
                                      date,
                                      requestEndLocation?.rlkArrivalEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Date should be before End location date",
                              },
                              {
                                func: (date) => {
                                  const firstViaLocation =
                                    getFirstViaLocation();
                                  if (firstViaLocation) {
                                    return isBefore(
                                      date,
                                      firstViaLocation.rlkArrivalEta
                                    );
                                  }
                                  return true;
                                },
                                message:
                                  "Date should be before first Via location",
                              },
                            ]
                          : [
                              {
                                func: (date) => {
                                  if (!requestStartLocation?.rlkDepartureEta)
                                    return true;

                                  const minArrival =
                                    subtractMinutesFromDateWithoutConvertingToJson(
                                      requestStartLocation?.rlkDepartureEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minArrival) ||
                                    isBefore(date, minArrival)
                                  );
                                },
                                message: `Arrival must be at least ${timeGapInMins} minutes before departure`,
                              },
                              {
                                func: (date) => {
                                  if (requestStartLocation?.rlkDepartureEta) {
                                    return isBefore(
                                      date,
                                      requestStartLocation?.rlkDepartureEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Arrival Date should be before departure date",
                              },
                              {
                                func: (date) => {
                                  if (requestEndLocation?.rlkArrivalEta) {
                                    return isBefore(
                                      date,
                                      requestEndLocation?.rlkArrivalEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Date should be before End location date",
                              },
                              {
                                func: (date) => {
                                  const firstViaLocation =
                                    getFirstViaLocation();
                                  if (firstViaLocation) {
                                    return isBefore(
                                      date,
                                      firstViaLocation.rlkArrivalEta
                                    );
                                  }
                                  return true;
                                },
                                message:
                                  "Date should be before first Via location",
                              },
                            ]
                      }
                      label="Arrival"
                      error={currentStartLocationErrors.rlkArrivalEta}
                      resetError={() =>
                        setCurrentStartLocationErrors((prevState) => {
                          const { rlkArrivalEta: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      required={true}
                    />
                    <DateTimePickerInput
                      readOnly={
                        viewOnlyMode ||
                        (editMode &&
                          requestStartLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      form={START_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_start_departure_eta"
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      value={requestStartLocation?.rlkDepartureEta}
                      style={{
                        borderColor: errors.departureTime ? "red" : "",
                      }}
                      onAccept={(value) => {
                        dispatch(
                          requestActions.setStartLocation({
                            rlkDepartureEta: value,
                          })
                        );
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          rlkDepartureEta: value,
                          rlkDepartureEtaFormatted: formatFromJsonDate(value),
                        }));
                      }}
                      validators={
                        !allowBackDates
                          ? [
                              {
                                func: (date) => isAfter(date, new Date()),
                                message:
                                  "Date and Time should be after current date and time",
                              },
                              {
                                func: (date) => {
                                  if (!requestStartLocation?.rlkArrivalEta)
                                    return true;

                                  const minDeparture =
                                    addMinutesToDateWithoutConvertingToJson(
                                      requestStartLocation?.rlkArrivalEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minDeparture) ||
                                    isAfter(date, minDeparture)
                                  );
                                },
                                message: `Departure must be at least ${timeGapInMins} minutes after arrival`,
                              },
                              {
                                func: (date) =>
                                  isAfter(
                                    date,
                                    requestStartLocation?.rlkArrivalEta
                                  ),
                                message: "Date should be after arrival date",
                              },
                            ]
                          : [
                              {
                                func: (date) =>
                                  isAfter(
                                    date,
                                    requestStartLocation?.rlkArrivalEta
                                  ),
                                message: "Date should be after arrival date",
                              },
                              {
                                func: (date) => {
                                  if (!requestStartLocation?.rlkArrivalEta)
                                    return true;

                                  const minDeparture =
                                    addMinutesToDateWithoutConvertingToJson(
                                      requestStartLocation?.rlkArrivalEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minDeparture) ||
                                    isAfter(date, minDeparture)
                                  );
                                },
                                message: `Departure must be at least ${timeGapInMins} minutes after arrival`,
                              },
                            ]
                      }
                      label="Departure"
                      error={currentStartLocationErrors.rlkDepartureEta}
                      resetError={() =>
                        setCurrentStartLocationErrors((prevState) => {
                          const { rlkDepartureEta: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      required={true}
                    />
                  </div>
                  <div className="two fields">
                    <Input
                      readOnly={
                        viewOnlyMode ||
                        (editMode &&
                          requestStartLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      editMode={editMode}
                      form={START_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_location_contact_name"
                      value={requestStartLocation.rlkLocationContactName}
                      onChange={(e) => {
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          rlkLocationContactName: e.target.value,
                        }));
                        dispatch(
                          requestActions.setStartLocation({
                            rlkLocationContactName: e.target.value,
                          })
                        );
                      }}
                      clearable={true}
                      label="Location Contact Person"
                      error={currentStartLocationErrors.rlkLocationContactName}
                      resetError={() =>
                        setCurrentStartLocationErrors((prevState) => {
                          const { rlkLocationContactName: _, ...rest } =
                            prevState;
                          return rest;
                        })
                      }
                    />
                    <Input
                      readOnly={
                        viewOnlyMode ||
                        (editMode &&
                          requestStartLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      label="Location Contact Number"
                      error={
                        currentStartLocationErrors.rlkLocationContactNumber
                      }
                      form={START_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_location_contact_number"
                      editMode={editMode}
                      clearable={true}
                      resetError={() =>
                        setCurrentStartLocationErrors((prevState) => {
                          const { rlkLocationContactNumber: _, ...rest } =
                            prevState;
                          return rest;
                        })
                      }
                      minLength={10}
                      value={requestStartLocation.rlkLocationContactNumber}
                      onChange={(e) => {
                        setRequestStartLocation((prevState) => ({
                          ...prevState,
                          rlkLocationContactNumber: e.target.value,
                        }));
                        dispatch(
                          requestActions.setStartLocation({
                            rlkLocationContactNumber: e.target.value,
                          })
                        );
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      justifyContent: "flex-end",
                      marginTop: "5px",
                    }}
                  >
                    <Button
                      disabled={!requestStartLocation?.rlkLocation}
                      className="ui primary right floated button"
                      label="Location Detaitls"
                      onClick={() => {
                        openPopUp(popupConst.START_LOCATION_DETAILS);
                      }}
                      Icon={Info}
                    />
                  </div>
                </div>
                <div className="ui segment">
                  <h4 className="ui dividing header">End Location</h4>
                  <div className="two fields">
                    <SearchDropdown
                      readOnly={
                        viewOnlyMode ||
                        (editMode && requestEndLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      disabled={
                        !requestStartLocation?.rlkArrivalEta ||
                        !requestStartLocation?.rlkDepartureEta
                      }
                      editMode={editMode}
                      multiGrid={true}
                      multiGridCurrentValue={requestEndLocation?.locationName}
                      reset={searchFieldReset}
                      form={END_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_end_location"
                      setReset={setSearchFieldReset}
                      api={getOtherRefDetails}
                      ref={endLocationRef}
                      returnFullObject={true}
                      threshold={1}
                      apiDependency={{
                        type: "location_customer",
                        value: locationCustomerId?.toString(),
                      }}
                      clearable={true}
                      onClear={() => {
                        dispatch(
                          requestActions.setEndLocation({
                            locationName: "",
                            rlkAddress: "",
                            rlkEmail: "",
                            rlkContactNumber: "",
                            rlkLon: null,
                            rlkLat: null,
                            rlkLocation: null,
                            rlkPickDrop: 2,
                          })
                        );
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          locationName: "",
                          rlkAddress: "",
                          rlkEmail: "",
                          rlkContactNumber: "",
                          rlkLon: null,
                          rlkLat: null,
                          rlkLocation: null,
                          rlkPickDrop: 2,
                        }));
                      }}
                      onResultSelect={(data) => {
                        dispatch(
                          requestActions.setEndLocation({
                            locationName: data.retField1,
                            rlkAddress: data.retField2,
                            rlkEmail: data.retField6,
                            rlkContactNumber: data.retField5,
                            rlkLon: data.retField9,
                            rlkLat: data.retField10,
                            rlkLocation: data.value,
                            rlkPickDrop: 2,
                          })
                        );
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          locationName: data.retField1,
                          rlkAddress: data.retField2,
                          rlkEmail: data.retField6,
                          rlkContactNumber: data.retField5,
                          rlkLon: data.retField9,
                          rlkLat: data.retField10,
                          rlkLocation: data.value,
                          rlkPickDrop: 2,
                        }));
                      }}
                      required={true}
                      label="Location"
                      error={currentEndLocationErrors.rlkLocation}
                      resetError={() =>
                        setCurrentEndLocationErrors((prevState) => {
                          const { rlkLocation: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />

                    <SearchDropdown
                      readOnly={
                        viewOnlyMode ||
                        (editMode && requestEndLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      disabled={
                        !requestStartLocation?.rlkArrivalEta ||
                        !requestStartLocation?.rlkDepartureEta
                      }
                      editMode={editMode}
                      reset={searchFieldReset}
                      form={END_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_end_contact_person"
                      setReset={setSearchFieldReset}
                      api={getOtherRefSearchDropdown}
                      value={requestEndLocation?.rlkContactPersonId}
                      apiDependency={{
                        type: "contact_person",
                        value: locationCustomerId?.toString(),
                      }}
                      clearable={true}
                      onClear={() => {
                        dispatch(
                          requestActions.setEndLocation({
                            rlkContactPersonId: null,
                          })
                        );
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          rlkContactPersonId: null,
                        }));
                      }}
                      onResultSelect={(data) => {
                        dispatch(
                          requestActions.setEndLocation({
                            rlkContactPersonId: data,
                          })
                        );
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          rlkContactPersonId: data,
                        }));
                      }}
                      fieldInfo={{
                        tableName: "masterdata.tms_m_contacts",
                        primaryKey: "con_id",
                        fieldName: "con_name",
                        id: requestEndLocation?.rlkContactPersonId,
                      }}
                      label="Contact Person"
                      error={currentEndLocationErrors.rlkContactPersonId}
                      resetError={() =>
                        setCurrentEndLocationErrors((prevState) => {
                          const { rlkContactPersonId: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                  </div>
                  <div className="two fields">
                    <DateTimePickerInput
                      readOnly={
                        viewOnlyMode ||
                        (editMode && requestEndLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      form={END_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_end_arrival_eta"
                      disabled={
                        !requestStartLocation?.rlkArrivalEta ||
                        !requestStartLocation?.rlkDepartureEta
                      }
                      value={requestEndLocation?.rlkArrivalEta}
                      style={{
                        borderColor: errors.departureTime ? "red" : "",
                      }}
                      onAccept={(value) => {
                        dispatch(
                          requestActions.setEndLocation({
                            rlkArrivalEta: value,
                          })
                        );
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          rlkArrivalEta: value,
                          rlkArrivalEtaFormatted: formatFromJsonDate(value),
                        }));
                      }}
                      validators={
                        !allowBackDates
                          ? [
                              {
                                func: (date) => isAfter(date, new Date()),
                                message:
                                  "Date and Time should be after current date and time",
                              },
                              {
                                func: (date) => {
                                  if (!requestEndLocation?.rlkDepartureEta)
                                    return true;

                                  const minArrival =
                                    subtractMinutesFromDateWithoutConvertingToJson(
                                      requestEndLocation?.rlkDepartureEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minArrival) ||
                                    isBefore(date, minArrival)
                                  );
                                },
                                message: `Arrival must be at least ${timeGapInMins} minutes before departure`,
                              },

                              {
                                func: (date) => {
                                  if (requestEndLocation?.rlkDepartureEta) {
                                    return isBefore(
                                      date,
                                      requestEndLocation?.rlkDepartureEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Arrival Date should be before departure date",
                              },
                              {
                                func: (date) => {
                                  const prevLocations =
                                    getPreviousLocation(null);
                                  if (prevLocations) {
                                    return isAfter(
                                      date,
                                      prevLocations.rlkDepartureEta
                                    );
                                  }

                                  if (requestStartLocation?.rlkDepartureEta) {
                                    return isAfter(
                                      date,
                                      requestStartLocation?.rlkDepartureEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Date should be after previous location departure",
                              },
                            ]
                          : [
                              {
                                func: (date) => {
                                  if (!requestEndLocation?.rlkDepartureEta)
                                    return true;

                                  const minArrival =
                                    subtractMinutesFromDateWithoutConvertingToJson(
                                      requestEndLocation?.rlkDepartureEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minArrival) ||
                                    isBefore(date, minArrival)
                                  );
                                },
                                message: `Arrival must be at least ${timeGapInMins} minutes before departure`,
                              },
                              {
                                func: (date) => {
                                  if (requestEndLocation?.rlkDepartureEta) {
                                    return isBefore(
                                      date,
                                      requestEndLocation?.rlkDepartureEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Arrival Date should be before departure date",
                              },
                              {
                                func: (date) => {
                                  const prevLocations =
                                    getPreviousLocation(null);
                                  if (prevLocations) {
                                    return isAfter(
                                      date,
                                      prevLocations.rlkDepartureEta
                                    );
                                  }

                                  if (requestStartLocation?.rlkDepartureEta) {
                                    return isAfter(
                                      date,
                                      requestStartLocation?.rlkDepartureEta
                                    );
                                  }

                                  return true;
                                },
                                message:
                                  "Date should be after previous location departure",
                              },
                            ]
                      }
                      label="Arrival"
                      error={currentEndLocationErrors.rlkArrivalEta}
                      resetError={() =>
                        setCurrentEndLocationErrors((prevState) => {
                          const { rlkArrivalEta: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      required={true}
                    />
                    <DateTimePickerInput
                      readOnly={
                        viewOnlyMode ||
                        (editMode && requestEndLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      form={END_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_end_departure_eta"
                      disabled={
                        !requestStartLocation?.rlkArrivalEta ||
                        !requestStartLocation?.rlkDepartureEta
                      }
                      value={requestEndLocation?.rlkDepartureEta}
                      style={{
                        borderColor: errors.departureTime ? "red" : "",
                      }}
                      onAccept={(value) => {
                        dispatch(
                          requestActions.setEndLocation({
                            rlkDepartureEta: value,
                          })
                        );
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          rlkDepartureEta: value,
                          rlkDepartureEtaFormatted: formatFromJsonDate(value),
                        }));
                      }}
                      validators={
                        !allowBackDates
                          ? [
                              {
                                func: (date) => isAfter(date, new Date()),
                                message:
                                  "Date and Time should be after current date and time",
                              },
                              {
                                func: (date) => {
                                  if (!requestEndLocation?.rlkArrivalEta)
                                    return true;

                                  const minDeparture =
                                    addMinutesToDateWithoutConvertingToJson(
                                      requestEndLocation?.rlkArrivalEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minDeparture) ||
                                    isAfter(date, minDeparture)
                                  );
                                },
                                message: `Departure must be at least ${timeGapInMins} minutes after arrival`,
                              },
                              {
                                func: (date) =>
                                  isAfter(
                                    date,
                                    requestEndLocation?.rlkArrivalEta
                                  ),
                                message: "Date should be after arrival date",
                              },
                            ]
                          : [
                              {
                                func: (date) => {
                                  if (!requestEndLocation?.rlkArrivalEta)
                                    return true;

                                  const minDeparture =
                                    addMinutesToDateWithoutConvertingToJson(
                                      requestEndLocation?.rlkArrivalEta,
                                      timeGapInMins
                                    );

                                  return (
                                    isSame(date, minDeparture) ||
                                    isAfter(date, minDeparture)
                                  );
                                },
                                message: `Departure must be at least ${timeGapInMins} minutes after arrival`,
                              },
                              {
                                func: (date) =>
                                  isAfter(
                                    date,
                                    requestEndLocation?.rlkArrivalEta
                                  ),
                                message: "Date should be after arrival date",
                              },
                            ]
                      }
                      label="Departure"
                      error={currentEndLocationErrors.rlkDepartureEta}
                      resetError={() =>
                        setCurrentEndLocationErrors((prevState) => {
                          const { rlkDepartureEta: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      required={true}
                    />
                  </div>
                  <div className="two fields">
                    <Input
                      readOnly={
                        viewOnlyMode ||
                        (editMode && requestEndLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      disabled={
                        !requestStartLocation?.rlkArrivalEta ||
                        !requestStartLocation?.rlkDepartureEta
                      }
                      editMode={editMode}
                      form={END_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_location_contact_name"
                      value={requestEndLocation.rlkLocationContactName}
                      onChange={(e) => {
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          rlkLocationContactName: e.target.value,
                        }));
                        dispatch(
                          requestActions.setEndLocation({
                            rlkLocationContactName: e.target.value,
                          })
                        );
                      }}
                      clearable={true}
                      label="Location Contact Person"
                      error={currentEndLocationErrors.rlkLocationContactName}
                      resetError={() =>
                        setCurrentEndLocationErrors((prevState) => {
                          const { rlkLocationContactName: _, ...rest } =
                            prevState;
                          return rest;
                        })
                      }
                    />

                    <Input
                      readOnly={
                        viewOnlyMode ||
                        (editMode && requestEndLocation?.rlkLocationTimeUpdated)
                      }
                      useDynamicFields={true}
                      disabled={
                        !requestStartLocation?.rlkArrivalEta ||
                        !requestStartLocation?.rlkDepartureEta
                      }
                      editMode={editMode}
                      form={END_LOCATION}
                      module={MODULES.Transaction}
                      field="rlk_location_contact_number"
                      value={requestEndLocation.rlkLocationContactNumber}
                      onChange={(e) => {
                        setRequestEndLocation((prevState) => ({
                          ...prevState,
                          rlkLocationContactNumber: e.target.value,
                        }));
                        dispatch(
                          requestActions.setEndLocation({
                            rlkLocationContactNumber: e.target.value,
                          })
                        );
                      }}
                      clearable={true}
                      label="Location Contact Number"
                      error={currentEndLocationErrors.rlkLocationContactNumber}
                      resetError={() =>
                        setCurrentEndLocationErrors((prevState) => {
                          const { rlkLocationContactNumber: _, ...rest } =
                            prevState;
                          return rest;
                        })
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      justifyContent: "flex-end",
                      marginTop: "5px",
                    }}
                  >
                    {!isViaLocationsVisible && (
                      <Button
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        className="ui primary right floated button"
                        label="Show Map Location"
                        onClick={onShowLocation}
                        Icon={MapPin}
                      />
                    )}
                    <Button
                      disabled={!requestEndLocation?.rlkLocation}
                      className="ui primary right floated button"
                      label="Location Detaitls"
                      onClick={() => {
                        openPopUp(popupConst.END_LOCATION_DETAILS);
                      }}
                      Icon={Info}
                    />
                  </div>
                </div>
                {isViaLocationsVisible && (
                  <div className="ui segment">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <h4
                        className="ui dividing header"
                        style={{ width: "70vw" }}
                      >
                        Via Locations
                      </h4>
                      {isBulkAddVisbile && allowBulkAddViaLocations && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            height: "30px",
                          }}
                        >
                          <Button
                            disabled={
                              editMode ||
                              viewOnlyMode ||
                              !requestStartLocation?.rlkArrivalEta ||
                              !requestStartLocation?.rlkDepartureEta ||
                              !requestEndLocation?.rlkArrivalEta ||
                              !requestEndLocation?.rlkDepartureEta ||
                              items?.length > 0
                            }
                            className="ui primary right floated button"
                            label="Bulk Add"
                            onClick={() => {
                              openPopUp(popupConst.VIA_LOCATION_ADD);
                            }}
                            Icon={Plus}
                            form={VIA_LOCATION}
                            useDynamicFields={true}
                          />
                        </div>
                      )}
                    </div>
                    <div className="two fields">
                      <SearchDropdown
                        readOnly={
                          viewOnlyMode ||
                          (editMode &&
                            requestViaLocation?.rlkLocationTimeUpdated)
                        }
                        useDynamicFields={true}
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        editMode={editMode}
                        multiGrid={true}
                        multiGridCurrentValue={requestViaLocation.locationName}
                        reset={viaSearchFieldReset}
                        form={VIA_LOCATION}
                        module={MODULES.Transaction}
                        field="rlk_via_location"
                        setReset={setViaSearchFieldReset}
                        ref={viaLocationRef}
                        api={getOtherRefSearchDropdown}
                        threshold={1}
                        apiDependency={{
                          type: "location_customer",
                          value: locationCustomerId?.toString(),
                        }}
                        clearable={true}
                        onClear={() => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkLocation: null,
                          }));
                        }}
                        onResultSelect={(data) => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkLocation: data,
                          }));
                        }}
                        required={true}
                        label="Location"
                        error={errors.rlkLocation}
                        resetError={() =>
                          setErrors((prevState) => {
                            const { rlkLocation: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                      />
                      <Dropdown
                        required={true}
                        label="Pick Drop Type"
                        form={VIA_LOCATION}
                        module={MODULES.Transaction}
                        field="rlk_pick_drop"
                        options={dropdown.pickDropTypeOptions}
                        value={requestViaLocation?.rlkPickDrop}
                        onChange={(e, data) => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkPickDrop: data.value,
                          }));
                        }}
                        readOnly={
                          viewOnlyMode ||
                          (editMode &&
                            requestViaLocation?.rlkLocationTimeUpdated)
                        }
                        useDynamicFields={true}
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        editMode={editMode}
                        error={errors.rlkPickDrop}
                        resetError={() =>
                          setErrors((prevState) => {
                            const { rlkPickDrop: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                      />
                    </div>
                    <div className="two fields">
                      <DateTimePickerInput
                        readOnly={
                          viewOnlyMode ||
                          (editMode &&
                            requestViaLocation?.rlkLocationTimeUpdated)
                        }
                        useDynamicFields={true}
                        form={VIA_LOCATION}
                        module={MODULES.Transaction}
                        field="rlk_via_arrival_eta"
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        value={requestViaLocation.rlkArrivalEta}
                        style={{
                          borderColor: errors.departureTime ? "red" : "",
                        }}
                        onAccept={(value) => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkArrivalEta: value,
                            rlkArrivalEtaFormatted: formatFromJsonDate(value),
                          }));
                        }}
                        validators={
                          !allowBackDates
                            ? [
                                {
                                  func: (date) => isAfter(date, new Date()),
                                  message:
                                    "Date and Time should be after current date and Time",
                                },
                                {
                                  func: (date) => {
                                    const prevLocations = getPreviousLocation(
                                      requestViaLocation.rlkSeq
                                    );
                                    if (prevLocations) {
                                      return isAfter(
                                        date,
                                        prevLocations.rlkDepartureEta
                                      );
                                    }

                                    if (requestStartLocation?.rlkDepartureEta) {
                                      return isAfter(
                                        date,
                                        requestStartLocation?.rlkDepartureEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be after previous location departure",
                                },
                                {
                                  func: (date) => {
                                    if (requestEndLocation?.rlkArrivalEta) {
                                      return isBefore(
                                        date,
                                        requestEndLocation?.rlkArrivalEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be before end location arrival",
                                },
                                {
                                  func: (date) => {
                                    if (!requestViaLocation?.rlkDepartureEta)
                                      return true;

                                    const minArrival =
                                      subtractMinutesFromDateWithoutConvertingToJson(
                                        requestViaLocation?.rlkDepartureEta,
                                        timeGapInMins
                                      );

                                    return (
                                      isSame(date, minArrival) ||
                                      isBefore(date, minArrival)
                                    );
                                  },
                                  message: `Arrival must be at least ${timeGapInMins} minutes before departure`,
                                },
                                {
                                  func: (date) => {
                                    if (requestViaLocation?.rlkDepartureEta) {
                                      return isBefore(
                                        date,
                                        requestViaLocation?.rlkDepartureEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be before current location depature",
                                },
                              ]
                            : [
                                {
                                  func: (date) => {
                                    const prevLocations = getPreviousLocation(
                                      requestViaLocation.rlkSeq
                                    );
                                    if (prevLocations) {
                                      return isAfter(
                                        date,
                                        prevLocations.rlkDepartureEta
                                      );
                                    }

                                    if (requestStartLocation?.rlkDepartureEta) {
                                      return isAfter(
                                        date,
                                        requestStartLocation?.rlkDepartureEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be after previous location departure",
                                },
                                {
                                  func: (date) => {
                                    if (requestEndLocation?.rlkArrivalEta) {
                                      return isBefore(
                                        date,
                                        requestEndLocation?.rlkArrivalEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be before end location arrival",
                                },
                                {
                                  func: (date) => {
                                    if (!requestViaLocation?.rlkDepartureEta)
                                      return true;

                                    const minArrival =
                                      subtractMinutesFromDateWithoutConvertingToJson(
                                        requestViaLocation?.rlkDepartureEta,
                                        timeGapInMins
                                      );

                                    return (
                                      isSame(date, minArrival) ||
                                      isBefore(date, minArrival)
                                    );
                                  },
                                  message: `Arrival must be at least ${timeGapInMins} minutes before departure`,
                                },
                                {
                                  func: (date) => {
                                    if (requestViaLocation.rlkDepartureEta) {
                                      return isBefore(
                                        date,
                                        requestViaLocation.rlkDepartureEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be before current location depature",
                                },
                              ]
                        }
                        label="Arrival"
                        error={errors.rlkArrivalEta}
                        resetError={() =>
                          setErrors((prevState) => {
                            const { rlkArrivalEta: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                        required={true}
                      />
                      <DateTimePickerInput
                        readOnly={
                          viewOnlyMode ||
                          (editMode &&
                            requestViaLocation?.rlkLocationTimeUpdated)
                        }
                        useDynamicFields={true}
                        form={VIA_LOCATION}
                        module={MODULES.Transaction}
                        field="rlk_via_departure_eta"
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        value={requestViaLocation.rlkDepartureEta}
                        style={{
                          borderColor: errors.departureTime ? "red" : "",
                        }}
                        onAccept={(value) => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkDepartureEta: value,
                            rlkDepartureEtaFormatted: formatFromJsonDate(value),
                          }));
                        }}
                        validators={
                          !allowBackDates
                            ? [
                                {
                                  func: (date) => isAfter(date, new Date()),
                                  message:
                                    "Date and Time should be after current date and time",
                                },
                                {
                                  func: (date) =>
                                    isAfter(
                                      date,
                                      requestViaLocation?.rlkArrivalEta
                                    ),
                                  message: "Date should be after arrival date",
                                },
                                {
                                  func: (date) => {
                                    if (requestEndLocation?.rlkArrivalEta) {
                                      return isBefore(
                                        date,
                                        requestEndLocation?.rlkArrivalEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be before end location arrival",
                                },
                                {
                                  func: (date) => {
                                    if (!requestViaLocation?.rlkArrivalEta)
                                      return true;

                                    const minDeparture =
                                      addMinutesToDateWithoutConvertingToJson(
                                        requestViaLocation?.rlkArrivalEta,
                                        timeGapInMins
                                      );

                                    return (
                                      isSame(date, minDeparture) ||
                                      isAfter(date, minDeparture)
                                    );
                                  },
                                  message: `Departure must be at least ${timeGapInMins} minutes after arrival`,
                                },
                              ]
                            : [
                                {
                                  func: (date) =>
                                    isAfter(
                                      date,
                                      requestViaLocation.rlkArrivalEta
                                    ),
                                  message: "Date should be after arrival date",
                                },
                                {
                                  func: (date) => {
                                    if (!requestViaLocation?.rlkArrivalEta)
                                      return true;

                                    const minDeparture =
                                      addMinutesToDateWithoutConvertingToJson(
                                        requestViaLocation?.rlkArrivalEta,
                                        timeGapInMins
                                      );

                                    return (
                                      isSame(date, minDeparture) ||
                                      isAfter(date, minDeparture)
                                    );
                                  },
                                  message: `Departure must be at least ${timeGapInMins} minutes after arrival`,
                                },
                                {
                                  func: (date) => {
                                    if (requestEndLocation?.rlkArrivalEta) {
                                      return isBefore(
                                        date,
                                        requestEndLocation?.rlkArrivalEta
                                      );
                                    }

                                    return true;
                                  },
                                  message:
                                    "Date should be before end location arrival",
                                },
                              ]
                        }
                        label="Departure"
                        error={errors.rlkDepartureEta}
                        resetError={() =>
                          setErrors((prevState) => {
                            const { rlkDepartureEta: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                        required={true}
                      />
                    </div>
                    <div className="two fields">
                      <SearchDropdown
                        readOnly={
                          viewOnlyMode ||
                          (editMode &&
                            requestViaLocation?.rlkLocationTimeUpdated)
                        }
                        useDynamicFields={true}
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        editMode={editMode}
                        reset={viaSearchFieldReset}
                        form={VIA_LOCATION}
                        module={MODULES.Transaction}
                        field="rlk_via_contact_person"
                        setReset={setViaSearchFieldReset}
                        api={getOtherRefSearchDropdown}
                        value={requestViaLocation.rlkContactPersonId}
                        apiDependency={{
                          type: "contact_person",
                          value: locationCustomerId?.toString(),
                        }}
                        clearable={true}
                        onClear={() => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkContactPersonId: null,
                          }));
                        }}
                        onResultSelect={(data) => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkContactPersonId: data,
                          }));
                        }}
                        fieldInfo={{
                          tableName: "masterdata.tms_m_contacts",
                          primaryKey: "con_id",
                          fieldName: "con_name",
                          id: requestViaLocation.rlkContactPersonId,
                        }}
                        label="Contact Person"
                        error={errors.rlkContactPersonId}
                        resetError={() =>
                          setErrors((prevState) => {
                            const { rlkContactPersonId: _, ...rest } =
                              prevState;
                            return rest;
                          })
                        }
                      />
                      <Input
                        readOnly={
                          viewOnlyMode ||
                          (editMode &&
                            requestViaLocation?.rlkLocationTimeUpdated)
                        }
                        useDynamicFields={true}
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        editMode={editMode}
                        form={VIA_LOCATION}
                        module={MODULES.Transaction}
                        field="rlk_location_contact_name"
                        value={requestViaLocation.rlkLocationContactName}
                        onChange={(e) => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkLocationContactName: e.target.value,
                          }));
                        }}
                        clearable={true}
                        label="Location Contact Person"
                        error={errors.rlkLocationContactName}
                        resetError={() =>
                          setErrors((prevState) => {
                            const { rlkLocationContactName: _, ...rest } =
                              prevState;
                            return rest;
                          })
                        }
                      />
                    </div>
                    <div className="two fields">
                      <Input
                        readOnly={
                          viewOnlyMode ||
                          (editMode &&
                            requestViaLocation?.rlkLocationTimeUpdated)
                        }
                        useDynamicFields={true}
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        editMode={editMode}
                        form={VIA_LOCATION}
                        module={MODULES.Transaction}
                        field="rlk_location_contact_number"
                        value={requestViaLocation.rlkLocationContactNumber}
                        onChange={(e) => {
                          setRequestViaLocation((prevState) => ({
                            ...prevState,
                            rlkLocationContactNumber: e.target.value,
                          }));
                        }}
                        clearable={true}
                        label="Location Contact Number"
                        error={errors.rlkLocationContactNumber}
                        resetError={() =>
                          setErrors((prevState) => {
                            const { rlkLocationContactNumber: _, ...rest } =
                              prevState;
                            return rest;
                          })
                        }
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        disabled={!requestViaLocation.rlkLocation}
                        className="ui primary right floated button"
                        label="Location Detaitls"
                        onClick={() => {
                          openPopUp(popupConst.VIA_LOCATION_DETAILS);
                        }}
                        Icon={Info}
                      />
                      <Button
                        template="reset"
                        onClick={(e) => {
                          setButtonClicked(true);
                        }}
                      />
                      <Button
                        disabled={
                          viewOnlyMode ||
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        template="addOrSave"
                        authenticated={true}
                        editMode={editMode}
                        module={MODULES.Transaction}
                        form={`${FORM}`}
                        create={Object.keys(currentItem).length === 0}
                        onClick={onAddClick}
                        isLoading={isAddLoading}
                      />
                    </div>
                    <Grid
                      isLoading={gridLoading}
                      onRowDragEnter={onRowDragEnter}
                      onRowDragEnd={onRowDragEnd}
                      rowDragManaged={true}
                      pagination={false}
                      cellSizeStrategy="fitCellContents"
                      fitContentCellls={[
                        "rlkContactPersonValue",
                        "rlkAddress",
                        "locationName",
                        "rlkPickDropValue",
                        "rlkEmail",
                        "rlkLocationContactName",
                        "rlkLocationContactNumber",
                      ]}
                      heading="Via Location List"
                      config={[
                        {
                          headerName: "Sequence",
                          field: "rlkSeq",
                          // rowDrag: context !== 3,
                          rowDrag: false,
                        },
                        {
                          headerName: "Location",
                          field: "locationName",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Arrival",
                          field: "rlkArrivalEtaFormatted",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Departure",
                          field: "rlkDepartureEtaFormatted",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Pick Drop Type",
                          field: "rlkPickDropValue",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Contact Person",
                          field: "rlkContactPersonValue",
                        },
                        {
                          headerName: "Location Contact Number",
                          field: "rlkLocationContactNumber",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Location Contact Name",
                          field: "rlkLocationContactName",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Location Address",
                          field: "rlkAddress",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },

                        {
                          headerName: "Location Address",
                          field: "rlkAddress",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Contact Number",
                          field: "rlkContactNumber",
                        },
                        {
                          headerName: "Email",
                          field: "rlkEmail",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        { headerName: "Longitude", field: "rlkLon" },
                        { headerName: "Latitude", field: "rlkLat" },
                        {
                          field: "Edit",
                          filter: true,
                          cellRenderer: ButtonRenderer,
                          cellRendererParams: (params) => ({
                            consider: AUTH_TYPES.CREATE,
                            clickHandler: () => {
                              setCurrentItem(params.data);
                            },
                            label: viewOnlyMode ? "View" : "Edit",
                            authenticated: true,
                            form: `${FORM}`,
                            module: MODULES.Transaction,
                            editMode: editMode,
                          }),
                        },
                        {
                          field: "Delete",
                          filter: true,
                          cellRenderer: DeleteButtonRenderer,
                          cellRendererParams: (params) => ({
                            consider: AUTH_TYPES.DELETE,
                            clickHandler: () => {
                              if (params.data.rlkId) {
                                setItems((prevState) =>
                                  prevState.filter(
                                    (item) => item.rlkId !== params.data.rlkId
                                  )
                                );
                                dispatch(
                                  requestActions.removeLocation({
                                    rlkId: params.data.rlkId,
                                    location: params.data.rlkLocation,
                                  })
                                );
                              } else {
                                setItems((prevState) =>
                                  prevState.filter(
                                    (item) => item.id !== params.data.id
                                  )
                                );
                                dispatch(
                                  requestActions.removeUnPersistedLocation({
                                    id: params.data.id,
                                    location: params.data.rlkLocation,
                                  })
                                );
                              }
                            },
                            label: "Delete",
                            disabled:
                              viewOnlyMode ||
                              (editMode && params.data?.rlkLocationTimeUpdated),
                            className: "ui red button",
                            authenticated: true,
                            form: `${FORM}`,
                            module: MODULES.Transaction,
                            editMode:
                              params.data.rlkId !== null &&
                              isNumber(params.data.rlkId),
                          }),
                        },
                      ]}
                      content={items}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "flex-end",
                        marginTop: "5px",
                      }}
                    >
                      <Button
                        disabled={
                          !requestStartLocation?.rlkArrivalEta ||
                          !requestStartLocation?.rlkDepartureEta
                        }
                        className="ui primary right floated button"
                        label="Show Map Location"
                        onClick={onShowLocation}
                        Icon={MapPin}
                      />
                    </div>
                  </div>
                )}
                {validationErrors && validationErrors.length > 0 && (
                  <UIMessage type="negative" width="100%" centered={false}>
                    <div className="content">
                      <div className="header">
                        There was some errors with your locations
                      </div>

                      <p>
                        <div className="content">
                          <ul>
                            {validationErrors.map((value) => (
                              <li>{value.error}</li>
                            ))}
                          </ul>
                        </div>
                      </p>
                    </div>
                  </UIMessage>
                )}
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default RequestLocationsRequest;
